import React, { useState, useEffect } from 'react';
import PopUp from '../../../../../commonModules/interface/PopUp';
import Currency from '../../../../../commonModules/Currency.jsx';
import { isEmpty } from 'lodash';
import { Grid, TableBody, TableRow, TableCell } from '@material-ui/core';
import { TableLayout } from '../../containers/Layout';

const translate = {
  new: 'Comme Neuf',
  very_good: 'Très bien',
  good: 'Bien',
  bad: 'Mauvais',
};

const SingleTransferReturnProduct = (props) => {
    const { handleClose, returnProd, product, client, saleInfo } = props;
    const [mainPhoto, setMainPhoto] = useState('');
    const [src, setSrc] = useState({});

    useEffect(() => {
        if (!isEmpty(returnProd.product_photos)) {
            getPhotos(returnProd.product_photos);
        }
    }, [returnProd.product_photos]);

    const getPhotos = (files) => {
        files.forEach((file) => {
            downloadFile(file.filename);
        });
        setMainPhoto(files[0].filename);
    };

    const photoList = () => {
        return returnProd.product_photos.map((pic) => (
            <div
                className="thumbnail col-xs-3"
                key={pic.filename}
                onClick={() => setMainPhoto(pic.filename)}
            >
                {pic.filename && <img id={pic.filename} src={src[pic.filename]} alt="" />}
                {!pic.filename && <img src="img/noImg.png" alt="" />}
            </div>
        ));
    };

    const downloadFile = async (path) => {
        try {
            const req = await fetch('/returns/getFile', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify({ path: path }),
                credentials: 'same-origin',
            });
            const response = await req.json();
            if (response.error) {
                console.error('[ERROR], fetching file ', response);
                return;
            }
            setSrc((prevSrc) => ({
                ...prevSrc,
                [path]: response.uri,
            }));
        } catch (err) {
            console.error('[ERROR], catch fetching file', err);
        }
    };

    return (
        <PopUp close={handleClose} title={`${returnProd.id.substring(0, 8)} | ${product.name} - ${product.marque}`}>
            <Grid container spacing={2}>
                <Grid item sm={6} xs={12}>
                    {!isEmpty(returnProd.product_photos) && (
                        <div className="">
                        <div className="thumbnail">
                            <img id="mainPhoto" src={src[mainPhoto || returnProd.product_photos[0]]} alt={product.name} />
                        </div>
                        <div className="">{photoList()}</div>
                        </div>
                    )}
                    {isEmpty(returnProd.product_photos) && (
                        <div className="thumbnail">
                        <img src="img/noImg.png" alt="" />
                        </div>
                    )}
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell>Prix de revente:</TableCell>
                                <TableCell>
                                <Currency value={returnProd.sell_price} />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Ancien Client:</TableCell>
                                {!isEmpty(client) && (
                                    <TableCell>{client.resume.idBox} - {client.resume.clientName}</TableCell>
                                )}
                                {!isEmpty(saleInfo) && (
                                    <TableCell>{
                                        `${saleInfo.client_firstname || saleInfo.client_firstname} - ${saleInfo.idBox || ''}`
                                    }</TableCell>
                                )}
                            </TableRow>
                            <TableRow>
                                <TableCell>Quantité:</TableCell>
                                <TableCell>{returnProd.product_quantity}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Durée d'utilisation:</TableCell>
                                <TableCell>{returnProd.use_length} mois</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Etat:</TableCell>
                                <TableCell>{translate[returnProd.product_state]}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>Description:</TableCell>
                                <TableCell>{returnProd.description}</TableCell>
                            </TableRow>
                        </TableBody>
                    </TableLayout>
                </Grid>
            </Grid>
        </PopUp>
    );
};

export default SingleTransferReturnProduct;
